















































































































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { FillInfoItemOfForm, OperationItemType, OptionItemType } from '../../types/type'
import axios from 'axios'
import Store, { CommonModule } from '../../store'
import { findOneForOrginationTree, getSuffix, getAllFatherNodeForIdList, getNameTextInOptions } from '../../utils/toolsForCommon'
import { encode } from 'js-base64'
@Component({
  name: 'formModule',
  components: {
    'my-dialog': () => import('../../components/common/myDialog.vue'),
    'loading-container': () => import('../../components/loading.vue'),
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue')
  }
})
export default class formModule extends Vue {
  @Prop({ default: '' }) public title: string
  @Prop({ default: '' }) public icon: string
  @Prop({ default: '' }) public contentTitle: string
  @Prop({ default: false }) public loading: false
  @Prop({ default: () => [] }) public fillInfoList: FillInfoItemOfForm[]
  @Prop({ default: () => [] }) public headerOperationList: OperationItemType[]
  @Prop({ default: () => [] }) public bottomOperationList: OperationItemType[]
  @Prop({ default: () => [] }) public needRequestDataForWho: string[]
  @Prop({ default: () => [] }) public subsidizeTypeOptions: OptionItemType[]
  @Prop({ default: false }) public onlyLook: boolean
  @Prop({ default: '#BBE0E3' }) public bgcOFSetTitle: string
  @Prop({ default: false }) public continuousButtonShow: boolean

  public whoHaveToUploadImageOfKey: string = '' // 谁正在上传

  // 以下针对无限列表：文件号选择，start：
  public dialogFlag: boolean = false
  public dialogContainerBodyTitleList: any[] = [
    {
      title: '操作',
      flex: '1'
    },
    {
      title: '资助项目',
      flex: '2'
    },
    {
      title: '文件号',
      flex: '2'
    },
    {
      title: '文件名',
      flex: '4'
    }
  ]
  public fileNumberList: any[] = []
  public fileNumberListForCurrentPage: number = 1
  public fileNumberListForPageSize: number = 10
  public fileNumberListForLoading: boolean = false
  public fileNumberListTotal: number = 0
  // 以上针对无限列表：文件号选择，end

  // 以下是针对无限列表：接收人员的选择，start：
  public dialogFlagForUser: boolean = false
  public dialogContainerBodyTitleListForUser: any[] = [
    {
      title: '操作',
      flex: '1'
    },
    {
      title: '用户名称',
      flex: '3'
    },
    {
      title: '手机号',
      flex: '2'
    },
    {
      title: '单位名称',
      flex: '3'
    }
  ]
  public userList: any[] = []
  public userListForCurrentPage: number = 1
  public userListForPageSize: number = 100
  public userListForLoading: boolean = false
  public userListTotal: number = 0
  // 以下是针对无限列表：接收人员的选择，end

  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false

  // 是否连续录入：
  public continuousValue = false

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  created () {
    // 特殊处理，看需要拿什么数据：比如这里拿到了文件号选择，由于是无限列表，直接写在子组件内获取：
    this.needRequestDataForWho.forEach(item => {
      switch (item) {
        case 'getFileNumberList':
          this.getFileNumberList()
          break
        case 'getUserList':
          this.getUserList()
          break
      }
    })
  }

  operationForButton (item: OperationItemType) {
    this.$emit('operationForButton', item)
  }

  itemContentClick (item: any) {
    // 暂时不做限制，本应该上一张没有上传完成就不能上传下一张：
    // 图片和文件都要走这里：
    if (item.type !== 'photo' && item.type !== 'file' && item.type !== 'photoForList') return
    this.whoHaveToUploadImageOfKey = item.key
  }

  // 暂时不作限制
  beforeUpload () {}

  uploadSelf (param) {
    this.uploadRealForImg(param, this.whoHaveToUploadImageOfKey)
  }

  // 单张图片上传方法：上传完成传递给父组件：暂时先这样，后期有时间进行封装
  async uploadRealForImg (param, who) {
    try {
      let _that: any = this
      let { data: result } = await _that.$http.uploadImg({
        suffix: getSuffix(param.file.name),
        path: 'canteen'
      })
      if (result.code !== 200) return _that.$message.error(result.msg)
      let reader = new FileReader()
      reader.readAsArrayBuffer(param.file)
      reader.onload = async function () {
        let onloadResult = reader.result
        await axios.put(result.data, onloadResult, {
          headers: {
            'Content-Type': 'image/jpg',
            authorization: Store.state.User.token
          }
        })
        _that.$message.success('图片上传成功')
        let pic = result.data.split('?')[0]
        _that.$emit('getFormResultFromChild', {
          key: _that.whoHaveToUploadImageOfKey,
          value: pic
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  uploadSelfForPhotoForList (param) {
    this.uploadRealForImgForPhotoForList(param, this.whoHaveToUploadImageOfKey)
  }

  // 多张图片上传方法：上传完成传递给父组件：暂时先这样，后期有时间进行封装
  async uploadRealForImgForPhotoForList (param, who) {
    try {
      let _that: any = this
      let { data: result } = await _that.$http.uploadImg({
        suffix: getSuffix(param.file.name),
        path: 'canteen'
      })
      if (result.code !== 200) return _that.$message.error(result.msg)
      let reader = new FileReader()
      reader.readAsArrayBuffer(param.file)
      reader.onload = async function () {
        let onloadResult = reader.result
        await axios.put(result.data, onloadResult, {
          headers: {
            'Content-Type': 'image/jpg',
            authorization: Store.state.User.token
          }
        })
        _that.$message.success('图片上传成功')
        let pic = result.data.split('?')[0]
        _that.$emit('getFormResultFromChild', {
          key: who,
          value: pic
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 多张图片上传：
  handleRemove (file, fileList) {
    setTimeout(() => {
      this.$emit('getFormResultForHandleRemoveForPhotoForList', {
        key: this.whoHaveToUploadImageOfKey,
        value: fileList
      })
    }, 10)
  }

  // 级联选择器：
  // 这里暂时只是为了：选择学校，拿到对应的乡镇或者学校，然后传递给父组件：
  cascaderChooseChange (value) {
    let _that: any = this
    let chooseItemForAllFather = getAllFatherNodeForIdList(value[value.length - 1], this.treeDataForOrganatizion)
    // 拿到乡镇的id:
    let idForTown = chooseItemForAllFather[chooseItemForAllFather.length - 2]
    // 拿到学校的id:
    let idForSchool = value[value.length - 1]
    // 分别找到相应的乡镇item和学校item:
    let resForTown = findOneForOrginationTree(this.treeDataForOrganatizion, idForTown)
    let resForSchool = findOneForOrginationTree(this.treeDataForOrganatizion, idForSchool)
    // 直接把乡镇学校对象传递过去：具体看子组件的逻辑处理：谨慎处理
    _that.$emit('getFormResultFromChild', {
      key: 'distributeTownshipName',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'distributeSchoolName',
      value: resForSchool
    })
    // 在校学生管理有用到：和上面两个一样，是乡镇和学校，但是key不同，后期考虑优化
    _that.$emit('getFormResultFromChild', {
      key: 'schoolBelong',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'organizationName',
      value: resForSchool
    })
    // 针对陪餐管理里面的乡镇和学校：
    _that.$emit('getFormResultFromChild', {
      key: 'villagesAndTownsForAddOrUpdateAccompanyMeal',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'organizationNameForAddOrUpdateAccompanyMeal',
      value: resForSchool
    })
    // 针对培训管理里面的乡镇和学校：
    _that.$emit('getFormResultFromChild', {
      key: 'villagesAndTownsForAddOrUpdateTrain',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'organizationNameForAddOrUpdateTrain',
      value: resForSchool
    })
    // 针对留样管理里面的乡镇和学校：
    _that.$emit('getFormResultFromChild', {
      key: 'villagesAndTownsForAddOrUpdateRetainSpecimen',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'organizationNameForAddOrUpdateRetainSpecimen',
      value: resForSchool
    })
    // 针对消杀管理里面的乡镇和学校：
    _that.$emit('getFormResultFromChild', {
      key: 'villagesAndTownsForAddOrUpdateDisinfect',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'organizationNameForAddOrUpdateDisinfect',
      value: resForSchool
    })
    // 针对人员管理里面的乡镇和学校：
    _that.$emit('getFormResultFromChild', {
      key: 'villagesAndTownsForAddOrUpdatePersonnel',
      value: resForTown
    })
    _that.$emit('getFormResultFromChild', {
      key: 'organizationNameForAddOrUpdatePersonnel',
      value: resForSchool
    })
  }

  // 输入框：
  inputChange (item) {
    let _that: any = this
    _that.$emit('getInputChange', item)
  }

  // 普通选择器：
  selectChange (item) {
    const _that: any = this
    _that.$emit('getSelectChange', item)
  }

  // 单选里面的选择器：
  selectChangeForRadioAndSelect (item) {
    let _that: any = this
    _that.$emit('getSelectChangeForRadioAndSelect', item)
  }

  cascaderForcodeChange (event, item) {
    ;(this as any).$emit('getCascaderForcodeChange', event, item)
  }

  selectChangeForChildInner (item) {
    let _that: any = this
    _that.$emit('getSelectChangeForChildInner', item)
  }

  // 一般是用来做中央，省级，县级的资金处理：
  childInputInput (v: FillInfoItemOfForm) {
    let _that: any = this
    _that.$emit('getChildInputValue')
  }

  // 无限滚动列表相关：start，获取文件号#####################################
  selectForPageListShow () {
    this.dialogFlag = true
  }
  hideMask () {
    this.dialogFlag = false
  }
  load () {
    // 应该有多少页：
    let _that: any = this
    let totalPages = Math.ceil(
      this.fileNumberListTotal / this.fileNumberListForPageSize
    )
    if (this.fileNumberListForCurrentPage >= totalPages) {
      if (totalPages > 1) {
        _that.$message.warning('没有更多数据啦！')
      }
    } else {
      this.fileNumberListForCurrentPage++
      this.getFileNumberList()
    }
  }
  // 获取文件号列表：即资助文件录入列表：
  async getFileNumberList () {
    try {
      let _that: any = this
      this.fileNumberListForLoading = true
      let pageParams = {
        pageNo: this.fileNumberListForCurrentPage,
        pageSize: this.fileNumberListForPageSize
      }
      // 下拉框用到此数据的时候：暂时不做搜索过滤,后期加进来
      let searchParams = {}
      let params = {
        ...pageParams,
        ...searchParams
      }
      let { data: result } = await _that.$http.capitalPoolListPage(params)
      this.fileNumberListForLoading = false
      if (result.code !== 200) return _that.$message.error(result.msg)
      let newGetFileNumberList = (
        (result.data && result.data.records) ||
        []
      ).map(item => {
        setTimeout(() => {
          item['grantName'] = getNameTextInOptions(
            this.subsidizeTypeOptions,
            item['grantName']
          )
        }, 300)
        item['checked'] = false
        return item
      })
      this.fileNumberList = [...this.fileNumberList, ...newGetFileNumberList]
      this.fileNumberListTotal = result.data.total
    } catch (err) {
      console.log(err)
    }
  }
  dialogConfirm () {
    let _that: any = this
    let checkedList = this.fileNumberList.filter(item => item.checked)
    _that.$emit('getFileNumberCheckedList', checkedList)
    this.hideMask()
  }
  // 无限滚动列表相关：end，获取文件号#####################################

  // 无限滚动列表相关：start，获取接收用户#####################################
  loadForUser () {
    // 应该有多少页：
    const totalPages = Math.ceil(this.userListTotal / this.userListForPageSize)
    if (this.userListForCurrentPage >= totalPages) {
      if (totalPages > 1) {
        this.$message.warning('没有更多用户啦！')
      }
    } else {
      this.userListForCurrentPage++
      this.getUserList()
    }
  }
  async getUserList (): Promise<any> {
    try {
      this.userListForLoading = true
      let pageParams = {
        pageNo: this.userListForCurrentPage,
        pageSize: this.userListForPageSize
      }
      // 下拉框用到此数据的时候：暂时不做搜索过滤,后期加进来
      let searchParams = {}
      let params = {
        ...pageParams,
        ...searchParams
      }
      let { data: result } = await (this as any).$http.getSysUserList(params)
      this.userListForLoading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      let newGetUserList = ((result.data && result.data.records) || []).map(item => {
        item['checked'] = false
        return item
      })
      this.userList = [...this.userList, ...newGetUserList]
      this.userListTotal = result.data.total
    } catch (err) {
      console.log(err)
    }
  }
  dialogConfirmForUser () {
    let _that: any = this
    let checkedList = this.userList.filter(item => item.checked)
    _that.$emit('getUserCheckedList', checkedList)
    this.dialogFlagForUser = false
  }
  // 无限滚动列表相关：end，获取接收用户#####################################

  // 上传文件：
  uploadSelfForFile (param) {
    this.uploadRealForFile(param, this.whoHaveToUploadImageOfKey)
  }

  // 文件上传方法：
  async uploadRealForFile (param, who) {
    try {
      let _that: any = this
      let haveUploading = this.fillInfoList.some(item => item.uploadSelfForImgForFileButtonFlag)
      if (haveUploading) return _that.$message.warning(`还有文件正在上传，请等待上传完成`)
      let res = this.fillInfoList.find(item => item.key === this.whoHaveToUploadImageOfKey)
      if (res.uploadSelfForImgForFileButtonFlag) return false
      let newFillInfoList = JSON.parse(JSON.stringify(this.fillInfoList)).map(item => {
        if (item.key === this.whoHaveToUploadImageOfKey) {
          item.uploadSelfForImgForFileButtonFlag = true
          item.uploadSelfForImgForFileButtonText = "<span class='el-icon-loading'></span>正在上传"
        }
        return item
      })
      this.$emit('updateFillInfoList', newFillInfoList)
      let params = {
        contentType: param.file.type,
        suffix: getSuffix(param.file.name)
      }
      let { data: result } = await _that.$http.uploadFile(params)
      if (result.code !== 200) {
        this.$message.error(result.msg)
        let newFillInfoList = JSON.parse(JSON.stringify(this.fillInfoList)).map(item => {
          if (item.key === this.whoHaveToUploadImageOfKey) {
            item.uploadSelfForImgForFileButtonFlag = false
            item.uploadSelfForImgForFileButtonText = item.uploadSelfForImgForFileButtonTextAgain
          }
          return item
        })
        this.$emit('updateFillInfoList', newFillInfoList)
        return false
      }
      let reader = new FileReader()
      reader.readAsArrayBuffer(param.file)
      reader.onload = async function () {
        let onloadResult = reader.result
        await axios.put(result.data, onloadResult, {
          headers: {
            'Content-Type': param.file.type,
            authorization: Store.state.User.token
          }
        })
        _that.$message.success('上传成功')
        let url = result.data.split('?')[0]
        let newFillInfoList = JSON.parse(JSON.stringify(_that.fillInfoList)).map(item => {
          if (item.key === _that.whoHaveToUploadImageOfKey) {
            item.uploadResultList.push({
              name: param.file.name,
              url
            })
          }
          return item
        })
        newFillInfoList = newFillInfoList.map(item => {
          if (item.key === _that.whoHaveToUploadImageOfKey) {
            item.uploadSelfForImgForFileButtonFlag = false
            item.uploadSelfForImgForFileButtonText = item.uploadSelfForImgForFileButtonTextAgain
          }
          return item
        })
        _that.$emit('updateFillInfoList', newFillInfoList)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    this.dialogVisibleForPreviewFile = true
    let previewUrl =
      _that.$previewURL +
      '/onlinePreview?url=' +
      encodeURIComponent(encode(v.url))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }

  operationOfdelete (item: any, v: any, k: number) {
    let _that: any = this
    _that
      .$confirm('确定要删除此文件吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
      .then(async () => {
        let key = item.key
        let newArr = JSON.parse(JSON.stringify(item.uploadResultList))
        newArr.splice(k, 1)
        _that.$message.success('删除成功！')
        let newFillInfoList = JSON.parse(JSON.stringify(this.fillInfoList)).map(
          vv => {
            if (vv.key === key) {
              vv.uploadResultList = newArr
            }
            return vv
          }
        )
        _that.$emit('updateFillInfoList', newFillInfoList)
      })
      .catch(() => {})
  }
}
